"use client";
import { useDialog } from "@/utils/DialogProvider";
import { useDrawer } from "@/utils/DrawerProvider";
import { UserSession } from "@/utils/types";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import { PrimaryBtn } from "./elements/Buttons";
import { LoginDialog } from "./dialogs/LoginDialog";
import AddSpecialOrderDrawer from "./drawers/AddSpecialOrderDrawer";
import Link from "next/link";
import { LuPlaneTakeoff, LuShoppingBasket } from "react-icons/lu";
import { CiShoppingBasket } from "react-icons/ci";
import { BiSearch } from "react-icons/bi";
import { IoCarSportOutline } from "react-icons/io5";
export const OrderBanner = () => {
  const { t, i18n } = useTranslation();
  const router = useRouter();

  return (
    <Link
      href="/make-to-order"
      className={
        "w100  br20 p50 mp15 mpb25 mpt25 c1 center tcenter  mc1 blue-bg grid  card-hover box-shadow br-dark-grey"
      }
      style={{
        backgroundColor: "#16489f",
        maxWidth: "300px",
        maxHeight: "300px",
      }}
    >
      <div className={"w100 grid gap20"}>
        <div className="">
          <div className=" grid gap5">
            <div className="c1 center">
              <div className=" white-bg br10 p20 mp10">
                <CiShoppingBasket color="#16489f"size={25}></CiShoppingBasket>
              </div>
              <div></div>
            </div>
            <h3 className=" hero-section-big-title white mf15">
              {t("Découvrez Notre Catalogue")}
            </h3>
            <p className="white web-only">{t("productsSubTitle")}</p>{" "}
          </div>
        </div>
        {/* <h4 className={"white f25 mf20 web-only"}>
        </h4> */}
        {/* <p className="white web-only">{t("ProductsHomeBanner")}</p> */}
      </div>
    </Link>
  );
};
export const HomeSpecialOrderBanner = () => {
  const { openDrawer } = useDrawer();
  const { openDialog } = useDialog();
  const { t, i18n } = useTranslation();

  return (
    <Link
      href="/import_china"
      className={
        " w100  br20 p50 mp15 mpb25 mpt25  c1 center tcenter   mc1  grid  card-hover box-shadow br-dark-grey"
      }
      style={{ maxWidth: "300px", maxHeight: "300px" }}
    >
      <div className={"w100 grid gap20"}>
        <div className=" grid gap5">
          <div className="c1 center ">
            <div className=" br10 p20 mp10 blue-bg">
              <LuPlaneTakeoff color=" #ffff"size={25}></LuPlaneTakeoff>
            </div>
            <div></div>
          </div>
          <h3 className=" hero-section-big-title blue  mf15">
            {t("specialOrdersAvailable")}
          </h3>
          <p className="web-only">{t("customProductSubTitle")}</p>{" "}
        </div>

        {/* <div className={"mc1 gap10 web-only"}>
            <br />
            <div></div>
          </div> */}
      </div>
    </Link>
  );
};
export const SpecialOrderBanner = () => {
  const { openDrawer } = useDrawer();
  const { openDialog } = useDialog();
  const session = useSession().data as UserSession;
  const router = useRouter();
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";

  return (
    <div
      // onClick={() => router.push("/import_china")}
      className={" w100  SpecialOrderBanner p100   mp50  mc1 blue-gradient-bg vcenter "}
    >
      <div>
        {" "}
        <div className={"w100 grid gap20"}>
          <div className=" grid gap5">
            <h3 className=" hero-section-big-title white f60 mf25">
              {t("specialOrdersAvailable")}
            </h3>
          </div>

          <>
            <h4 className={"white f30 mf20 "}>{t("findMissingProduct")} </h4>
            <p className="white f17 ">{t("specialOrderDescription")}</p>
          </>

          <div className={"auto-c1 mc1 gap10"}>
            <div>
              <div onClick={(e) => e.stopPropagation()}>
                <PrimaryBtn
                  text={t("orderNow")}
                  submit={() => {
                    if (!session?.role) {
                      openDialog("", <LoginDialog />);
                      return;
                    }
                    openDrawer({
                      title: t("specialOrder"),
                      content: (
                        <AddSpecialOrderDrawer
                          handleError={(e: Error) => console.error(e)}
                          handleSuccess={() => {
                            return;
                          }}
                        />
                      ),
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SourcingBanner = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation();

  return (
    <Link
      href="/sourcing"
      // onClick={() => router.push("/sourcing")}
      className={
        " w100  br20 p50 mp15 mpb25 mpt25 c1 center tcenter  mc1  grid  card-hover box-shadow br-dark-grey"
      }
      style={{ maxWidth: "300px", maxHeight: "300px" }}
    >
      <div className={"w100 grid gap20"}>
        <div className=" grid gap5">
          <div className=" c1 center">
            <div className="blue-bg br10 p20 mp10">
              <BiSearch color=" #ffff"size={25} />
            </div>
            <div></div>
          </div>
          <h3 className=" hero-section-big-title blue  mf15">
            {t("sourcingBigTilte")}
          </h3>{" "}
          <p className="web-only">{t("sourcingSubTitle")}</p>{" "}
        </div>
        <></>
      </div>
    </Link>
  );
};
export const CarsBanner = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation();

  return (
    <Link
      href="/cars"
      // onClick={() => router.push("/sourcing")}
      className={
        " w100  br20 p50 mp15 mpb25 mpt25 c1 center tcenter  mc1 grid  box-shadow card-hover"
      }
      style={{
        backgroundColor: "#16489f",
        maxWidth: "300px",
        maxHeight: "300px",
      }}
    >
      <div className={"w100 grid gap20"}>
        <div className=" grid gap5">
          <div className=" c1 center">
            <div className=" white-bg br10 p20 mp10">
              <IoCarSportOutline color=" #16489f"size={25} />
            </div>
            <div></div>
          </div>
          <h3 className="white hero-section-big-title  mf15">
            {t("discoverOurCars")}
          </h3>{" "}
          <p className="white web-only">{t("carsSubTitle")}</p>{" "}
        </div>
        <></>
      </div>
    </Link>
  );
};
